<a href="{{course.content_url}}" target="_blank" (click)="activateCourse()">
  <img src="{{course.splash_image_url}}" width="900" height="506" />
  <br />
  Click here to access the digital edition of the magazine
</a>
